/**
 * @function convertToUpperSnakeCase
 * @param {string} str string to convert
 * @description Converts a string to upper snake case (FOO_BAR), replaces hyphens and spaces
 * @returns {string}
 */
const convertToUpperSnakeCase = (str: string): string => str.toLocaleUpperCase().replace(/-| /g, "_");

export default convertToUpperSnakeCase;
